import React from "react";
import PageWrapper from "./category.style";
import { connect } from "react-redux";
import CategoryViewDetails from "../../components/category/CategoryViewDetails";
import PageTitle from "components/common/PageTitle";

const StaticPageView = props => {
  return (
    <PageWrapper {...props}>
      <div className="pos-relative">
        <PageTitle
          props={props}
          title="sidebar.category"
          className="plr-15"
          breadCrumb={[
            {
              name: "sidebar.dashboard",
              url: "/dashboard"
            },
            {
              name: "sidebar.category",
              url: "/category"
            },
            {
              name: "action.view"
            }
          ]}
        />
        <div
          className="back-icon fs-15 demi-bold-text cursor-pointer"
          onClick={() => props.history.push("/category")}
        >
          <i className="fas fa-step-backward"></i> Back
        </div>
      </div>
      <div className="user-tbl">
        <CategoryViewDetails {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger
  };
};

export default connect(mapStateToProps, null)(StaticPageView);
